const currencies = [
  {
    id: "INR",
    name: "Indian Rupee",
  },
  {
    id: "USD",
    name: "United States Dollar",
  },
  {
    id: "AUD",
    name: "Australian Dollar",
  },
  {
    id: "BRL",
    name: "Brazilian Real",
  },
  {
    id: "CAD",
    name: "Canadian Dollar",
  },
  {
    id: "CHF",
    name: "Swiss Franc",
  },
  {
    id: "CLP",
    name: "Chilean Peso",
  },
  {
    id: "CNY",
    name: "Chinese Yuan",
  },
  {
    id: "CZK",
    name: "Czech Koruna",
  },
  {
    id: "DKK",
    name: "Danish Krone",
  },
  {
    id: "EUR",
    name: "Euro",
  },
  {
    id: "GBP",
    name: "Pound Sterling",
  },
  {
    id: "HKD",
    name: "Hong Kong Dollar",
  },
  {
    id: "HUF",
    name: "Hungarian Forint",
  },
  {
    id: "IDR",
    name: "Indonesian Rupiah",
  },
  {
    id: "ILS",
    name: "Israeli New Shekel",
  },
  {
    name: "Japanese Yen",
    id: "JPY",
  },
  {
    name: "South Korean Won",
    id: "KRW",
  },
  {
    id: "MXN",
    name: "Mexican Peso",
  },
  {
    id: "MYR",
    name: "Malaysian Ringgit",
  },
  {
    id: "NOK",
    name: "Norwegian Krone",
  },
  {
    id: "NZD",
    name: "New Zealand Dollar",
  },
  {
    name: "Philippine Peso",
    id: "PHP",
  },
  {
    id: "PKR",
    name: "Pakistani Rupee",
  },
  {
    id: "PLN",
    name: "Polish Zloty",
  },
  {
    id: "RUB",
    name: "Russian Ruble",
  },
  {
    id: "SEK",
    name: "Swedish Krone",
  },
  { id: "SGD", name: "Singapore Dollar" },
  {
    id: "THB",
    name: "Thai Baht",
  },
  { id: "TRY", name: "Turkish Lira" },
  { id: "TWD", name: "New Taiwan Dollar" },
  { id: "ZAR", name: "South African Rand" },
];
export default currencies;
